import { createAction, RSAAAction } from 'redux-api-middleware'
import type { RootState } from '../../reducers'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'
import ActionTypes from './actionTypes'

interface CompleteMultipartUploadPayload {
    location: string;
}

type CompleteMultipartUploadRequest = {
    type: typeof ActionTypes.COMPLETE_MULTIPART_UPLOAD_REQUEST;
    payload: never;
}

type CompleteMultipartUploadSuccess = {
    type: typeof ActionTypes.COMPLETE_MULTIPART_UPLOAD_SUCCESS;
    payload: CompleteMultipartUploadPayload;
}

type CompleteMultipartUploadFailure = {
    type: typeof ActionTypes.COMPLETE_MULTIPART_UPLOAD_FAILURE;
    payload: Error;
}

export type CompleteMultipartUploadAction = CompleteMultipartUploadRequest
    | CompleteMultipartUploadSuccess
    | CompleteMultipartUploadFailure

export type CompleteMultipartUploadSAAAction = RSAAAction<
    RootState,
    CompleteMultipartUploadPayload | Error,
    never
> 

interface CompleteMultipartUploadParams {
    filename: string;
    parts: {
        PartNumber: number;
        ETag: string;
    }[];
    uploadId: string;
}

/**
 * Get presigned URL for uploading a file chunk
 * @param upload
 * @param upload.filename
 * @param upload.partNumber
 * @param upload.uploadId
 * @param opts
 * @param opts.basePath
 */
function completeMultipartUpload(
    { filename, parts, uploadId }: CompleteMultipartUploadParams,
    opts?: { basePath?: string },
): CompleteMultipartUploadSAAAction {
    const { basePath = HUBBLE_API_TOKEN } = opts ?? {}

    return createAction<RootState, CompleteMultipartUploadPayload | Error, never>({
        endpoint: `${basePath}/upload/${uploadId}`,
        method: 'POST',
        body: JSON.stringify({
            filename,
            parts,
        }),
        types: [
            ActionTypes.COMPLETE_MULTIPART_UPLOAD_REQUEST,
            ActionTypes.COMPLETE_MULTIPART_UPLOAD_SUCCESS,
            ActionTypes.COMPLETE_MULTIPART_UPLOAD_FAILURE,
        ],
    }) 
}

export default completeMultipartUpload
